export const options = ['Kidney', 'Heart', 'Lung', 'Liver', 'Pancreas', 'Intestines'];
